// Termíny školení pro mateřské školy 2026
export const terminyMS = [
  // Únor 2026 (od půlky měsíce)
  {
    id: 1,
    month: 'Únor 2026',
    lekce1: 'Út 17. 2.',
    lekce2: 'Út 24. 2.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 2,
    month: 'Únor 2026',
    lekce1: 'Čt 19. 2.',
    lekce2: 'Čt 26. 2.',
    cas: '8:00–11:45',
    typ: 'ranní',
    typIcon: '🌅'
  },
  
  // Březen 2026
  {
    id: 3,
    month: 'Březen 2026',
    lekce1: 'Út 3. 3.',
    lekce2: 'Út 10. 3.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 4,
    month: 'Březen 2026',
    lekce1: 'Čt 5. 3.',
    lekce2: 'Čt 12. 3.',
    cas: '8:00–11:45',
    typ: 'ranní',
    typIcon: '🌅'
  },
  {
    id: 5,
    month: 'Březen 2026',
    lekce1: 'Út 17. 3.',
    lekce2: 'Út 24. 3.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 6,
    month: 'Březen 2026',
    lekce1: 'Čt 19. 3.',
    lekce2: 'Čt 26. 3.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  
  // Duben 2026 (Velikonoční Po 6. 4.)
  {
    id: 7,
    month: 'Duben 2026',
    lekce1: 'Út 7. 4.',
    lekce2: 'Út 14. 4.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 8,
    month: 'Duben 2026',
    lekce1: 'Čt 9. 4.',
    lekce2: 'Čt 16. 4.',
    cas: '8:00–11:45',
    typ: 'ranní',
    typIcon: '🌅'
  },
  {
    id: 9,
    month: 'Duben 2026',
    lekce1: 'Út 21. 4.',
    lekce2: 'Út 28. 4.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 10,
    month: 'Duben 2026',
    lekce1: 'Čt 23. 4.',
    lekce2: 'Čt 30. 4.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  
  // Květen 2026
  {
    id: 11,
    month: 'Květen 2026',
    lekce1: 'Út 5. 5.',
    lekce2: 'Út 12. 5.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 12,
    month: 'Květen 2026',
    lekce1: 'Čt 7. 5.',
    lekce2: 'Čt 14. 5.',
    cas: '8:00–11:45',
    typ: 'ranní',
    typIcon: '🌅'
  },
  {
    id: 13,
    month: 'Květen 2026',
    lekce1: 'Út 19. 5.',
    lekce2: 'Út 26. 5.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 14,
    month: 'Květen 2026',
    lekce1: 'Čt 21. 5.',
    lekce2: 'Čt 28. 5.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  
  // Červen 2026 (jen první polovina)
  {
    id: 15,
    month: 'Červen 2026',
    lekce1: 'Út 2. 6.',
    lekce2: 'Út 9. 6.',
    cas: '14:00–17:45',
    typ: 'odpolední',
    typIcon: '🌇'
  },
  {
    id: 16,
    month: 'Červen 2026',
    lekce1: 'Čt 4. 6.',
    lekce2: 'Čt 11. 6.',
    cas: '8:00–11:45',
    typ: 'ranní',
    typIcon: '🌅'
  }
];

// Seskupení termínů podle měsíců
export const terminyMSByMonth = terminyMS.reduce((acc, termin) => {
  if (!acc[termin.month]) {
    acc[termin.month] = [];
  }
  acc[termin.month].push(termin);
  return acc;
}, {});

// Termíny pro ZŠ (stejné jako MŠ)
export const terminyZS = terminyMS;
export const terminyZSByMonth = terminyMSByMonth;
